if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;
 
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }
 
      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }
 
      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');
 
        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);
 
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }
 
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }
 
        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);
 
        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
 
      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
 
        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
 
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
 
      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }
 
      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }
 
      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
 
      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
 
/* ------------------------------------------------------------------
   PLAINVIEW: show only the selected flavor's images.
   Tag an image by starting its alt text with the flavor in brackets,
   like [Original] or [Spicy]. Images with no tag show for every flavor.
   The tag is removed from the alt text on the page.
   Only runs on products that have an option named "Flavor".
------------------------------------------------------------------- */
(function () {
  var TAG = /^\s*\[([^\]]+)\]\s*/;
 
  function getData() {
    var info = document.querySelector('product-info[data-product]');
    if (!info) return null;
    try {
      return JSON.parse(info.dataset.product);
    } catch (e) {
      return null;
    }
  }
 
  function flavorPosition(data) {
    var opts = data.options || [];
    for (var i = 0; i < opts.length; i++) {
      var name = typeof opts[i] === 'string' ? opts[i] : opts[i] && opts[i].name;
      if (String(name).toLowerCase().trim() === 'flavor') return i + 1;
    }
    return 0;
  }
 
  function currentVariant(data) {
    var id = new URLSearchParams(window.location.search).get('variant');
    if (!id) {
      var input = document.querySelector('product-info form[action*="/cart/add"] input[name="id"]');
      if (input) id = input.value;
    }
    if (!id) return null;
    for (var i = 0; i < data.variants.length; i++) {
      if (String(data.variants[i].id) === String(id)) return data.variants[i];
    }
    return null;
  }
 
  /* The theme only shows the active image on desktop. After a flavor change the theme can mark a
     hidden image as active, which leaves the big image blank. This puts the active image back
     onto a visible one. It runs every tick, not only when the flavor changes. */
  function ensureActiveVisible(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer || typeof gallery.setActiveMedia !== 'function') return;
 
    /* clean up: only a slide <li> may be active, never the inner element that has the plain media id */
    viewer.querySelectorAll('[data-media-id].is-active:not(li)').forEach(function (el) {
      el.classList.remove('is-active');
    });
 
    var items = viewer.querySelectorAll('li[data-media-id]');
    var firstVisible = null;
    for (var i = 0; i < items.length; i++) {
      if (items[i].style.display !== 'none') {
        firstVisible = items[i];
        break;
      }
    }
    if (!firstVisible) return;
    var active = viewer.querySelector('li[data-media-id].is-active');
    if (!active || active.style.display === 'none') {
      try {
        gallery.setActiveMedia(firstVisible.dataset.mediaId, false);
      } catch (e) {}
    }
  }
 
  function applyFlavorFilter() {
    var gallery = document.querySelector('media-gallery');
    var data = getData();
    if (!gallery || !data) return;
 
    var pos = flavorPosition(data);
    if (!pos) return;
 
    var variant = currentVariant(data);
    if (!variant) return;
 
    var flavor = String(variant['option' + pos]).toLowerCase().trim();
    var itemCount = gallery.querySelectorAll('li[data-media-id], li[data-target]').length;
    var stamp = flavor + '|' + itemCount;
 
    if (gallery.dataset.pvAppliedFlavor !== stamp) {
      gallery.dataset.pvAppliedFlavor = stamp;
 
      var visibleCount = 0;
      gallery.querySelectorAll('li[data-media-id], li[data-target]').forEach(function (li) {
        if (li.dataset.pvFlavor === undefined) {
          var img = li.querySelector('img');
          var alt = img ? img.getAttribute('alt') || '' : '';
          var match = TAG.exec(alt);
          li.dataset.pvFlavor = match ? match[1].toLowerCase().trim() : '';
          if (match && img) img.setAttribute('alt', alt.replace(TAG, ''));
        }
        var tag = li.dataset.pvFlavor;
        var hide = tag !== '' && tag !== flavor;
        li.style.display = hide ? 'none' : '';
        if (!hide && li.hasAttribute('data-media-id')) visibleCount++;
      });
 
      var total = gallery.querySelector('.slider-counter--total');
      if (total) total.textContent = visibleCount;
 
      var viewer = gallery.querySelector('[id^="GalleryViewer"]');
      var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
      if (viewer && typeof viewer.initPages === 'function') viewer.initPages();
      if (thumbs && typeof thumbs.initPages === 'function') thumbs.initPages();
    }
 
    ensureActiveVisible(gallery);
  }
 
  applyFlavorFilter();
  document.addEventListener('DOMContentLoaded', applyFlavorFilter);
  window.setInterval(applyFlavorFilter, 150);
})();